var state = {
    routeLevel: {},
};
var getters = {
    getRouteLevelLayout: function (state) { return function (name) {
        var layout = state.routeLevel[name] || null;
        return layout;
    }; },
};
var actions = {
    setRouteLevelLayout: function (_a, _b) {
        var commit = _a.commit;
        var name = _b.name, value = _b.value;
        commit('setRouteLevelLayout', { name: name, value: value });
    },
};
var mutations = {
    setRouteLevelLayout: function (state, _a) {
        var name = _a.name, value = _a.value;
        state.routeLevel[name] = value;
    },
};
export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
};



//////////////////
// WEBPACK FOOTER
// ./src/stores/modules/layout.store.ts
// module id = null
// module chunks = 